import { render, staticRenderFns } from "./ListApraisal.vue?vue&type=template&id=37ad7c4d&scoped=true&"
import script from "./ListApraisal.vue?vue&type=script&lang=js&"
export * from "./ListApraisal.vue?vue&type=script&lang=js&"
import style0 from "./ListApraisal.vue?vue&type=style&index=0&id=37ad7c4d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad7c4d",
  null
  
)

export default component.exports